import { render, staticRenderFns } from "./ClassicUi.vue?vue&type=template&id=23d51220&scoped=true"
import script from "./ClassicUi.vue?vue&type=script&lang=js"
export * from "./ClassicUi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d51220",
  null
  
)

export default component.exports